import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { ymPushParams } from '@fttb/common/utils';
import { sendCheckAddressPhoneClickAnalytics, sendCheckAddressToTariffsAnalytics, sendDeviceClickAddAnalytics, sendDeviceClickMoreAnalytics, sendFAQTabClickAnalytics } from "../../../blocks/analytics";
import { getAnalyticEventType, isPageTypeFmc } from "../selectors";
import { getCurrentDevices, getDeviceAlias, getDeviceTitle } from "../devices/selectors";
import { openDeviceModal } from "../devices/slice";
import { getClickedFAQTitle } from "../faq/selectors";
import { getAvailableStatusActionHref } from "./selectors";
export var onCallablePhoneClickAnalytics = function onCallablePhoneClickAnalytics() {
  return function (dispatch, getState) {
    var state = getState();
    var pageType = getAnalyticEventType(state);
    var isConvergent = isPageTypeFmc(state);
    sendCheckAddressPhoneClickAnalytics(pageType, isConvergent);
  };
};
export var onAnchorClickSlideToTariff = function onAnchorClickSlideToTariff() {
  return function (dispatch, getState) {
    var state = getState();
    var href = getAvailableStatusActionHref(state);
    var pageType = getAnalyticEventType(state);
    sendCheckAddressToTariffsAnalytics(pageType);
    if (href.includes('#')) {
      var elem = document.getElementById(href.replace('#', ''));
      elem.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
};
export var onDevicesViewAnalitics = function onDevicesViewAnalitics() {
  return function (dispatch, getState) {
    var state = getState();
    var devices = getCurrentDevices(state);
    var pageType = getAnalyticEventType(state);
    var deviceTitles = devices.map(function (_ref) {
      var title = _ref.title;
      return {
        view: title
      };
    });
    ymPushParams(_defineProperty({}, pageType, {
      device: _toConsumableArray(deviceTitles)
    }));
  };
};
export var onDeviceClickAnalitics = function onDeviceClickAnalitics() {
  return function (dispatch, getState) {
    var state = getState();
    var deviceTitle = getDeviceTitle(state);
    var pageType = getAnalyticEventType(state);
    sendDeviceClickAddAnalytics(pageType, deviceTitle);
  };
};
export var onDeviceClickMoreAnalitics = function onDeviceClickMoreAnalitics() {
  return function (dispatch, getState) {
    var state = getState();
    var deviceTitle = getDeviceTitle(state);
    var deviceAlias = getDeviceAlias(state);
    var pageType = getAnalyticEventType(state);
    sendDeviceClickMoreAnalytics(pageType, deviceTitle);
    dispatch(openDeviceModal(deviceAlias));
  };
};
export var onFAQTabClickAnalytics = function onFAQTabClickAnalytics(_ref2) {
  var panelId = _ref2.panelId;
  return function (dispatch, getState) {
    var state = getState();
    var faqTitle = getClickedFAQTitle(state, panelId);
    var pageType = getAnalyticEventType(state);
    sendFAQTabClickAnalytics(pageType, faqTitle);
  };
};